
import React from 'react';
import { Box, Heading, Text } from 'grommet';

import BackLink from './BackLink';
import Page from './Page';

const ORGANISATIONS = [
    '1. Ústav vinohradnictví a vinařství, Zahradnická fakulta, Mendelova univerzita v Brně, Valtická 337, 691 44 Lednice, Česká republika',
    '2. Historický ústav, Filozofická fakulta, Masarykova univerzita, Žerotínovo nám. 617/9, 601 77 Brno, Česká republika',
    '3. Mendeleum - ústav genetiky, Zahradnická fakulta, Mendelova univerzita v Brně, Valtická 337, 691 44 Lednice, Česká republika',
    '4. Ústav zelinářství a květinářství, Zahradnická fakulta, Mendelova univerzita v Brně, Valtická 337, 691 44 Lednice, Česká republika',
    '5. Ústav agrochemie, půdoznalství, mikrobiologie a výživy rostlin, Agronomická fakulta, Mendelova univerzita v Brně, Zemědělská 1, 613 00 Brno, Česká republika',
    '6. Ústav geologie a pedologie, Lesnická a dřevařská fakulta, Mendelova univerzita v Brně, Zemědělská 1, 613 00 Brno, Česká republika',
    '7. Ústav biologie rostlin, Agronomická fakulta, Mendelova univerzita v Brně, Zemědělská 1, 613 00 Brno, Česká republika',
    '8. BIC Brno spol. s r.o., objekt Technology Innovation Transfer Chamber, Purkyňova 648/125, 612 00 Brno, Česká republika'
];

const PERSONS = [
    'Radek Sotolář [1]',
    'Martin Markel [2]',
    'Kateřina Baránková [3]',
    'Tomáš Kopta [4]',
    'Martin Brtnický [5]',
    'Miroslav Havlík [2]',
    'Lucie Ragasová [4]',
    'David Juřička [6]',
    'Jan Winkler [7]',
    'Jindřich Kynický [8]',
    'Mojmír Baroň [1]',
    'Martin Vlk [1]',
    'Pavel Sedlář [1]',
    'Jiří Sochor [1]'
];

const AutorPage = () => {

    return (
        <Page>
            <Heading level={1} color="titleColor" >Autorský kolektiv</Heading>

            <Box pad={{bottom: '32px'}}>
                <Text size="large">Příjemcem projektu je Zahradnická fakulta Mendelovy univerzity v Brně, přičemž řešiteli jsou vědečtí pracovníci Ústavu vinohradnictví a vinařství. Odborný výzkumný tým v rámci realizovaného software zpracoval data historicky i aktuálně pěstovaných odrůd ve vybraných lokalitách Vinařské oblasti Morava. Pozornost byla zaměřena na odrůdové složení jednotlivých tratí a na informace o genetické příbuznosti a šlechtění vybraných odrůd. Tato data byla doplněna o informace k jednotlivým viničním tratím.</Text>
            </Box>

            <Box pad={{bottom: '32px'}}>
                <Text size="large">
                    {PERSONS.join(', ')}
                </Text>
            </Box>

            <Box pad={{bottom: '32px'}}>
                {ORGANISATIONS.map((item, index) => {
                    return <Text key={index} size="small">{item}</Text>;
                })}
            </Box>

            <BackLink link={`/`} title="Zpět na úvodní stránku" />
        </Page>
    );
}

export default AutorPage;
